import React from "react";
import { Link } from "react-router-dom";

const LinkUrl = (props) => {
  const niceUrl = props.to ? props.to.substring(props.to.indexOf("/") + 2) : "";
  const validUrl = props.to ? props.to.substring(props.to.indexOf("/") + 2) : "";
  return <Link to={validUrl}>{niceUrl}</Link>;
};
export default LinkUrl;
